import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import StarRegularReport from './star-regular-report-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <StarRegularReport {...validProps} />;
}

SvgComponent.iconName = 'starRegularReport';

export const StarRegularReportIcon = svgIconWrapper(SvgComponent);
